import React, {Component} from 'react';
import { Icon } from 'antd';

class InterviewInfo extends Component {
  state = {
    isShowTable: false
  }

  render() {
    const { isShowTable } = this.state;
    const { i18n, userInfo, paperInfo, themeColor } = this.props;

    return (
      <div className="video-mobile-box interviewInfo">
        <h1 className="interviewInfoTitle" style={{color: themeColor}}>{i18n.result.interviewTitle}</h1>
        <ul className={`interviewInfoCon ${isShowTable ? '' : 'interviewInfoCons'}`}>
          <li>
            <span>{i18n.result.videoTime}</span>
            <p>{userInfo && userInfo.startTimeStr}~{userInfo && userInfo.endTimeStr}</p>
          </li>
          <li>
            <span>{i18n.result.paperName}</span>
            <p>{i18n.lang === 'en_us' ? paperInfo && paperInfo.paperNameEn : paperInfo && paperInfo.paperName}</p>
          </li>
          <li>
            <span>{i18n.result.postName}</span>
            <p>{userInfo && userInfo.postName}</p>
          </li>
          <li>
            <span>{i18n.result.videoResource}</span>
            <p>{userInfo && userInfo.videoResource}</p>
          </li>
          <li>
            <span>{i18n.result.submitStatus}</span>
            <p>{userInfo && userInfo.submitStatusDesc}</p>
          </li>
          <li>
            <span>{i18n.result.finishTimes}</span>
            <p>{userInfo && userInfo.finishTime}</p>
          </li>
          <li>
            <span>{i18n.result.recordStatus}</span>
            <p>{userInfo && userInfo.statusDesc}</p>
          </li>
        </ul>
        <div className="showBtn">
          <span onClick={() => this.setState({isShowTable: !isShowTable})} style={{color: themeColor}}>{isShowTable ? i18n.result.downText : i18n.result.upText}<Icon type={isShowTable ? 'up' : 'down'} /></span>
        </div>
      </div>
    );
  }
}

export default InterviewInfo;
